<template>
  <div>
    {{ titleBeforeHasPartners }} <span class="text-primary"> IPC Partners</span>hip {{ titleAfterHasPartners }}
  </div>
</template>

<script setup lang="ts">
const { title } = defineProps<{ title: string }>()
const hasPartners = computed(() => title.includes('IPC Partnership'))

const titleBeforeHasPartners = computed(() => {
  if (hasPartners.value) {
    return title.split('IPC Partnership')[0]
  }
  return title
})

const titleAfterHasPartners = computed(() => {
  if (hasPartners.value) {
    return title.split('IPC Partnership')[1]
  }
  return ''
})
</script>

<style scoped>

</style>
